const Colors = {
  darkgrey: "#121212",
};

export default Colors;
